export default __webpack_public_path__ + "static/media/26.66759b84.png";